import React, { useContext, useState } from "react";
import { CommandBarButton, ConfirmDialog, Theme, useNotifications } from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderDashboardContext } from "../provider/OrderDashboardContext";

export const ApproveOrderDeliveryButton: React.VFC = () => {
    const { approveOrderDelivery } = useOrdersModuleApi();

    const { orderId, orderDashboardItem, approveDelivery } = useContext(OrderDashboardContext);
    const { status: orderStatus } = orderDashboardItem;

    const disabled = !isOrderReadyForDelivery(orderStatus);

    const { success } = useNotifications();

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = () => {
        setIsOpen(true);
    };

    const close = () => {
        setIsOpen(false);
    };

    const approve = async () => {
        await approveOrderDelivery({ orderId });

        approveDelivery();

        success("Delivery approved");

        close();
    };

    return (
        <>
            <CommandBarButton
                text="Approve"
                styles={{ root: { background: Theme.palette.neutralLighterAlt } }}
                disabled={disabled}
                icon="EntitlementRedemption"
                onClick={open}
                testId={"approve-order-delivery-button"}
            />
            <ConfirmDialog
                title="Approve order delivery"
                text="Are you sure you want to deliver this order? This action is irreversible."
                hidden={!isOpen}
                confirm={{ onClick: approve }}
                cancel={{ onClick: close }}
            />
        </>
    );
};

const isOrderReadyForDelivery = (orderStatus: OrderStatus): boolean =>
    orderStatus === OrderStatus.Encoded ||
    orderStatus === OrderStatus.DeliveryFailed ||
    orderStatus === OrderStatus.DeliveryError;
